import { Controller } from "@hotwired/stimulus"

/**
 * Kindle Verification Controller
 *
 * Loading states for the send-test and confirm-receipt buttons.
 * The actual form submission is handled by Turbo (button_to forms).
 *
 * Values (localized labels passed from the view):
 * - sendingLabel: text shown on the send button while submitting
 * - confirmingLabel: text shown on the confirm button while submitting
 */
export default class extends Controller {
  static targets = ["sendButton", "confirmButton"]
  static values = {
    sendingLabel: { type: String, default: "Sending..." },
    confirmingLabel: { type: String, default: "Confirming..." }
  }

  /**
   * Handle send button click - show loading state, then submit
   */
  send(event) {
    event.preventDefault()

    if (this.hasSendButtonTarget) {
      const button = this.sendButtonTarget
      const form = button.closest("form")

      this.#showLoading(button, this.sendingLabelValue)

      // Brief pause so the state change is visible before navigation
      setTimeout(() => {
        form.requestSubmit()
      }, 1000)
    }
  }

  /**
   * Handle confirmation button click - show loading state
   * (the form submits normally; disabling is deferred so it isn't blocked)
   */
  confirm(event) {
    if (this.hasConfirmButtonTarget) {
      const button = this.confirmButtonTarget

      setTimeout(() => {
        this.#showLoading(button, this.confirmingLabelValue)
      }, 0)
    }
  }

  #showLoading(button, label) {
    button.disabled = true
    button.classList.add("opacity-50", "cursor-wait")

    if (button.tagName === "INPUT") {
      button.value = label
    } else {
      button.textContent = label
    }
  }
}
